// if (type === 1) {
//     theme = 'blue.scss'
// }
// const type = '';

function getCookie(cookieName) {
    var strCookie = document.cookie;
    var arrCookie = strCookie.split("; ");
    for (var i = 0; i < arrCookie.length; i++) {
        var arr = arrCookie[i].split("=");
        if (cookieName === arr[0]) {
            return arr[1];
        }
    }
    return "";
}

function hexToRgba(val) { //HEX十六进制颜色值转换为RGB(A)颜色值， 将rgba转成单个字符串
    var a, b, c;
    if ((/^#/g).test(val)) {
        a = val.slice(1, 3);
        b = val.slice(3, 5);
        c = val.slice(5, 7);
        return { rgba: 'rgba(' + parseInt(a, 16) + ',' + parseInt(b, 16) + ',' + parseInt(c, 16) + ',0.1)' };
    } else {
        return { rgba: '无效值：' + val };
    }
}

function hexToRgbaObj(val) { //HEX十六进制颜色值转换为RGB(A)颜色值， 将rgba转成对象
    var a, b, c;
    let obj = {};
    if ((/^#/g).test(val)) {
        a = val.slice(1, 3);
        b = val.slice(3, 5);
        c = val.slice(5, 7);
        obj = {
            r: parseInt(a, 16),
            g: parseInt(b, 16),
            b: parseInt(c, 16),
        }
        return obj;
    } else {
        return { rgba: '无效值：' + val };
    }
}


// 初始加载判断cookie是否有type
// function loadTheme() {
//     let type = getCookie('type');
//     console.log(typeof(type))
//     let themeCss = '';
//     if (type === '') {
//         document.cookie = 'type=' + '0';
//     }
//     if (type === '0') {
//         themeCss = require('../style/theme/defaultTheme.scss');
//     } else if (type === '1') {
//         themeCss = require('../style/theme/blueTheme.scss');
//     } else if (type === '2') {
//         themeCss = require('../style/theme/redTheme.scss');
//     }
//     return themeCss;
// }
// 选择皮肤
// function setTheme(type) {
//     let themeCss = ''
//     if (type === '0') {
//         themeCss = 'defaultTheme'
//     } else if (type === '1') {
//         themeCss = 'blueTheme'
//     } else if (type === '2') {
//         themeCss = 'redTheme'
//     }
//     return require('../style/theme/' + themeCss + '.scss')
//         // return require.ensure([], () => r(require('../style/theme/' + themeCss + '.scss')), 'index')
// }
// 保存至cookie皮肤类型

export { getCookie, hexToRgba, hexToRgbaObj };